<template>
    <div class="alert_overlay" @click="onCancel">
        <div class="alert_card" @click.stop>
            <div class="beta_badge">BETA</div>
            <template v-if="step === 0">
                <div class="alert_title">엘리트 선수 인증 필요</div>
                <div class="alert_contents">
                    시크릿 프로필은 <span style="font-weight: 700;">JOINKFA</span> 엘리트 선수 전용입니다.<br>아래 예시와 같이 KFA 등록증 캡처본을 준비해 주세요.
                </div>
                <div style="margin-top: 5px;">
                    <img style="width: 100%;" :src="require('@/assets/img/elite_registration.png')" alt="">
                </div>
                <div style="margin-top: 5px; background-color: #F1E3FF; box-shadow: 0px 0px 15px 0px #00000040; border-radius: 12px; padding: 12px;">
                    <div style="display: flex; gap: 7px; align-items: center; justify-content: center;">
                        <div>
                            <img style="width: 12px;" :src="require('@/assets/img/capture_method.png')" alt="">
                        </div>
                        <div style="font-weight: 700; font-size: 12px; color: #9e4cf6;">캡처본 발급방법</div>
                    </div>
                    <div style="display: flex; gap: 8px; align-items: center; margin-top: 12px; justify-content: center;">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">JOINKFA 앱</div>
                        <img style="width: 9px;" :src="require('@/assets/img/right_arrow_method.png')" alt="">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">전체 메뉴</div>
                        <img style="width: 9px;" :src="require('@/assets/img/right_arrow_method.png')" alt="">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">회원정보</div>
                    </div>
                    <div style="margin-top: 7px; display: flex; gap: 8px; align-items: center; justify-content: center;">
                        <img style="width: 9px;" :src="require('@/assets/img/right_arrow_method.png')" alt="">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">선수/축구 선택</div>
                        <img style="width: 9px;" :src="require('@/assets/img/right_arrow_method.png')" alt="">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">KFA등록증</div>
                        <img style="width: 9px;" :src="require('@/assets/img/right_arrow_method.png')" alt="">
                        <div style="font-weight: 700; font-size: 11px; line-height: 16px;">캡처하기</div>
                    </div>
                </div>
                <div style="margin-top: 5px; text-align: center;">
                    <div style="font-weight: 700; font-size: 12px; line-height: 20px; color: #9e4cf6;">얼굴과 성함, 소속팀이 나오면 됩니다</div>
                </div>
                <div class="alert_btns">
                    <div class="alert_btn cancel" @click="onCancel">취소</div>
                    <div class="alert_btn ok" @click="onReadyClick">준비 완료</div>
                </div>
            </template>
            <template v-if="step === 1">
                <template v-if="!isConfirmStep">
                    <div class="alert_title">엘리트 선수 인증 필요</div>
                    <div class="alert_contents">
                        시크릿 프로필은 JOINKFA에<br>
                        등록된 엘리트 선수 전용 기능입니다.<br>
                        안전한 매칭을 위해 인증을 진행해 주세요.
                    </div>
                    <div class="attach_label">증빙 자료 첨부</div>
                    <div class="upload_row hide_scroll">
                        <div v-for="i in 5" :key="'slot' + i" class="upload_slot">
                            <div v-if="!imgSrcArr[i - 1]" class="upload_empty" @click="showFiles(i - 1)">
                                <img class="upload_icon" :src="require('@/assets/img/img_icon_white.png')" alt="">
                                <div class="upload_text">{{ i === 1 ? '[필수] 미디어 추가' : '미디어 추가' }}</div>
                            </div>
                            <div v-else class="upload_preview">
                                <img class="preview_img" :src="imgSrcArr[i - 1].src" alt="">
                                <div class="delete_btn" @click="deleteImg(i - 1)">
                                    <img :src="require('@/assets/img/delete_img.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <input v-for="i in 5" :key="'file' + i" type="file" accept="image/*" style="display:none;" :ref="'file' + (i - 1)" :data-id="'file' + (i - 1)" @change="readURL($event)">
                    <div class="alert_btns">
                        <div class="alert_btn cancel" @click="onCancel">취소</div>
                        <div class="alert_btn ok" :class="{ disabled: !hasImage }" @click="onAuthClick">엘리트 인증하기</div>
                    </div>
                </template>
    
                <template v-else>
                    <div class="alert_title">제출 전 확인해주세요</div>
                    <div class="alert_contents confirm_contents">
                        제출하신 증빙 자료는 관리자가 직접 검토합니다.<br>
                        추후 확인 시 <span class="highlight">엘리트 선수가 아니거나 허위 자료</span>로
                        판명될 경우, 시크릿 모드가 즉시 공개(일반)
                        상태로 강제 전환되며 서비스 이용이
                        제한될 수 있습니다.
                    </div>
                    <div class="confirm_question">그래도 엘리트 인증을 진행하시겠습니까?</div>
                    <div class="alert_btns">
                        <div class="alert_btn cancel" @click="onBackToUpload">취소</div>
                        <div class="alert_btn ok" @click="onSubmit">동의하고 제출</div>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import { PLAYER_TYPE } from '@/Constants'

export default {
    name: 'ElitePlayerAuthAlert',
    data() {
        return {
            isConfirmStep: false,
            imgSrcArr: [null, null, null, null, null],
            curIndex: 0,
            step: 0,
        }
    },
    props: {
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        hasImage() {
            return this.imgSrcArr.some(item => !!item)
        }
    },
    mounted() {
        this.$GlobalStore.addPopFlag(() => {
            this.onCancel()
        })
    },
    methods: {
        onCancel() {
            if (this.isConfirmStep) {
                this.onBackToUpload()
                return
            }
            this.$GlobalStore.closeLastModal()
        },
        onBackToUpload() {
            this.isConfirmStep = false
        },
        onReadyClick() {
            this.step = 1
        },
        onAuthClick() {
            if (!this.hasImage) {
                this.$GlobalStore.showAlert('이미지를 한 장 이상 첨부해 주세요')
                return
            }
            this.isConfirmStep = true
        },
        async onSubmit() {
            const isSuccess = await this.submit()
            if (isSuccess) {
                this.$GlobalStore.closeLastModal()
            }
        },
        async submit() {
            const formData = new FormData()
            formData.append('type', PLAYER_TYPE.ELITE)

            let hasFile = false
            for (let i = 0; i < 5; i++) {
                const file = this.imgSrcArr[i]?.file
                if (!file) continue
                formData.append('file' + i, file)
                hasFile = true
            }

            if (!hasFile) {
                this.$GlobalStore.showAlert('이미지를 한 장 이상 첨부해 주세요')
                return false
            }

            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
            })

            try {
                const res = await this.$Axios.post('/api/member/elite_player/certify', formData)
                this.$GlobalStore.closeLastModal()

                if (res.data.code === 0) {
                    this.$GlobalStore.loginInfo().is_elite_player = 1
                    this.completeAction()
                    return true
                }

                this.$GlobalStore.showAlert(res.data.msg)
                return false
            } catch (e) {
                this.$GlobalStore.closeLastModal()
                this.$GlobalStore.showAlert('제출 중 오류가 발생했습니다.')
                return false
            }
        },
        showFiles(index) {
            this.curIndex = index
            const ref = this.$refs['file' + index]
            const input = Array.isArray(ref) ? ref[0] : ref
            if (input) input.click()
        },
        deleteImg(i) {
            this.$set(this.imgSrcArr, i, null)
            const ref = this.$refs['file' + i]
            const input = Array.isArray(ref) ? ref[0] : ref
            if (input) input.value = ''
        },
        readURL(e) {
            const input = e.currentTarget
            if (!(input.files && input.files[0])) return

            const extension = input.files[0].name.split('.').pop().toLowerCase()
            if (!['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp'].includes(extension)) {
                this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp만 업로드 가능합니다.')
                input.value = ''
                return
            }

            const index = Number((input.getAttribute('data-id') || '').replace('file', ''))
            const reader = new FileReader()
            reader.onload = (ev) => {
                if (input.files[0].size > 1024 * 1024 * 1024) {
                    input.value = ''
                    this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.')
                    return
                }
                this.$set(this.imgSrcArr, index, {
                    src: ev.target.result,
                    id: input.getAttribute('data-id'),
                    isFileTag: true,
                    file: input.files[0],
                })
            }
            reader.readAsDataURL(input.files[0])
        },
    }
}
</script>

<style scoped>
.alert_overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.alert_card {
    width: calc(100% - 24px);
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;
}

.beta_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 0 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    background: linear-gradient(90deg, #D230FE 0%, #7179EC 100%);
}

.alert_title {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    color: #210F03;
}

.alert_contents {
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
    color: #210F03;
}

.confirm_contents {
    margin-top: 10px;
    font-weight: 500;
}

.highlight {
    color: #9E4CF6;
    font-weight: 700;
    font-size: 16px;
}

.confirm_question {
    margin-top: 25px;
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: #210F03;
}

.attach_label {
    margin-top: 15px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    color: #210F03;
}

.upload_row {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    overflow-x: auto;
    margin-left: -24px;
    margin-right: -24px;
    padding: 0 24px;
}

.upload_slot {
    flex-shrink: 0;
    width: 200px;
    height: 200px;
}

.upload_empty {
    width: 100%;
    height: 100%;
    background: #d9d9d9;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    box-sizing: border-box;
}

.upload_icon {
    width: 32px;
}

.upload_text {
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    color: #fff;
}

.upload_preview {
    position: relative;
    width: 100%;
    height: 100%;
}

.preview_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

.delete_btn {
    position: absolute;
    right: 6px;
    bottom: 6px;
}

.delete_btn img {
    width: 28px;
}

.alert_btns {
    display: flex;
    gap: 8px;
    margin-top: 22px;
}

.alert_btn {
    flex: 1;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    box-sizing: border-box;
}

.alert_btn.cancel {
    background: #F5F5F5;
    color: #210F03;
}

.alert_btn.ok {
    background: #9E4CF6;
    color: #fff;
}

.alert_btn.ok.disabled {
    background: #9E4CF666;
    color: #fff;
}

.hide_scroll::-webkit-scrollbar {
    display: none;
}

.hide_scroll {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
